var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../common-theme/api/agency.service';
import { Injector, OnInit } from '@angular/core';
import { EmbedVideoService } from '../common-theme/index';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var HomeComponent = /** @class */ (function (_super) {
    __extends(HomeComponent, _super);
    function HomeComponent(agencyService, embedService, injector) {
        var _this = _super.call(this, injector) || this;
        _this.agencyService = agencyService;
        _this.embedService = embedService;
        _this.injector = injector;
        _this.youtubeUrl = 'https://www.youtube.com/watch?v=xDW-IrCqaW8';
        _this.images = [
            { url: '/assets/images/home/slider/0.jpg' },
            { url: '/assets/images/home/slider/1.jpg' },
            { url: '/assets/images/home/slider/2.jpg' },
            { url: '/assets/images/home/slider/3.jpg' },
            { url: '/assets/images/home/slider/4.jpg' },
            { url: '/assets/images/home/slider/5.jpg' },
            { url: '/assets/images/home/slider/6.jpg' },
            { url: '/assets/images/home/slider/7.jpg' }
        ];
        _this.bannerOpened = false;
        return _this;
    }
    HomeComponent.prototype.ngOnInit = function () {
        this.videoInnerHTML = this.embedService.embed(this.youtubeUrl);
        this.setTitle('Romanescu Park Residence, Craiova');
        this.setMetaDescription("\n      Complex reziden\u021Bial de amploare din Craiova, Romanescu Park este situat \u00EEn imediata\n      apropiere a unuia dintre cele mai mari parcuri din ora\u0219, Romanescu. Proiectul include 14 cl\u0103diri\n      ce respect\u0103 toate exigen\u021Bele unui cartier modern, cum sunt locurile de parcare sau spa\u021Bii de\n      joac\u0103 pentru cei mici.\n    ");
    };
    return HomeComponent;
}(SeoAwareBaseComponent));
export { HomeComponent };



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts.pre-build-optimizer.js